import { render } from "./showResult.vue?vue&type=template&id=20a591c3&scoped=true"
import script from "./showResult.vue?vue&type=script&lang=js"
export * from "./showResult.vue?vue&type=script&lang=js"

import "./showResult.vue?vue&type=style&index=0&id=20a591c3&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a591c3"]])

export default __exports__